<template>
	<div :class="holderClass">
		<template v-if="buttonStyle != 'none'">
			<button
				class="tool-tip__label tool-tip__label--absolute"
				v-if="buttonStyle == 'tooltip'"
				:class="buttonClass"
				@click="openModal"
				:title="title">i</button>
			<button
				class="button"
				v-if="buttonStyle == 'button'"
				:class="buttonClass"
				@click="openModal"
				:title="title">{{ buttonText }}</button>
			<button
				class="description__button"
				v-if="buttonStyle == 'descriptionButton'"
				:class="buttonClass"
				@click="openModal"
				:title="title">{{ buttonText }}</button>
			<p
				class="cursor-pointer"
				v-if="buttonStyle == 'custom'"
				:class="buttonClass"
				@click="openModal"
				:title="title">{{ buttonText }}</p>
			<span
				class="text-link--underline cursor-pointer"
				v-if="buttonStyle == 'inline'"
				:class="buttonClass"
				@click.stop="openModal"
				:title="title">{{ buttonText }}</span>
		</template>
		<slot
			name="button"
			@click="openModal"/>
		<transition name="fade">
			<div
				class="configurator-modal"
				v-if="active"
				:class="{ 'configurator-modal--styled' : modalStyle == 'styled'}">
				<div
					class="modal-backdrop"
					@click="dismiss"/>
				<div class="modal-holder">
					<div class="modal-inner">
						<div
							class="modal-header"
							:class="{ 'modal-header--plain' : ['styled','plain'].includes(modalStyle)}">
							<div>
								<div
									class="h2 modal-title"
									v-if="title != ''"
									:class="{ 'title--dot' : modalStyle == 'styled'}">{{ title }}</div>
							</div>
							<button
								class="modal-close"
								@click="dismiss">&times;</button>
						</div>
						<div
							class="modal-content"
							:class="{'modal-content--styled' : modalStyle == 'styled'}">
							<slot/>
						</div>
						<div
							class="modal-footer"
							v-if="showFooter">
							<slot name="footer">
								<button
									class="button button--grey-light"
									@click="closeModal">Sluiten</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "Modal",
	props: {
		title: {
			type: String,
			default: ""
		},
		buttonStyle: {
			type: String,
			default: "button"
		},
		buttonText: {
			type: String,
			default: "Informatie"
		},
		open: {
			type: Boolean,
			default: false
		},
		modalStyle: {
			type: String,
			default: ""
		},
		buttonClass: {
			type: String,
			default: ""
		},
		holderClass: {
			type: String,
			default: ""
		}
	},
	data () {
		return {
			active: false
		};
	},
	computed: {
		showFooter () {
			return !["styled", "plain"].includes(this.modalStyle) || !!this.$slots.footer;
		}
	},
	methods: {
		openModal () {
			this.active = true;
			this._savedOverflow = document.documentElement.style.overflow;
			document.documentElement.style.overflow = "hidden";
		},
		closeModal () {
			this.active = false;
			document.documentElement.style.overflow = this._savedOverflow || "";
			this._savedOverflow = null;
		},
		dismiss () {
			this.$emit("close");
			this.closeModal();
		}
	},
	watch: {
		open (a, b) {
			if (a) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	}
};
</script>

<style lang="scss">
.configurator-modal {
  position: fixed;
  z-index: 200;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  overflow-y: auto;
  justify-content: center;

  &--styled .modal-holder {
	max-width: 720px;
	width: 100%;
  }
}

.modal-content--styled {
  padding: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  position: fixed;
}

.modal-holder {
  z-index: 200;
  padding: 30px 15px;
  position: relative;
  display: flex;
  align-items: flex-start;
}
.modal-inner {
  background: #fff;
  border-radius: 5px;
  padding: 25px 30px 30px;
  max-width: 1000px;
  width: 100%;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 15px;

  &--plain {
	border-bottom: none;
	margin-bottom: 0;
	padding-bottom: 0;
  }
}

.modal-title {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 15px;

  .button--white {
	border-width: 2px;
	border-color: var(--cfg-primary-border);
  }
}

.modal-close {
  padding: 10px;
  font-size: 30px;
  line-height: 20px;
  font-weight: 900;
  color: #999;
  justify-self: flex-end;
  cursor: pointer;

  &:hover {
	color: #505050;
  }
}

.table__data {
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/element/modal.vue